export const mockDeliveryDateData = {
  committedDeliveryDate: "10 OCT 2026",
  frozenAt: "01 OCT 2026 10:00:12 AM",
  destination: "411001 · PUN-01",
  reservation: "RES-889977",
  items: [
    {
      id: "1",
      name: "HR Coil 2.5 × 1250 mm",
      subtitle: "T1S · VM-042",
      quantity: "10 MT",
      materialReady: "0 h",
      serviceCentre: "12 h",
      processing: "46 h",
      logistics: "36 h",
      nonWorking: "16 h",
      committedDate: "06 OCT 2026",
      isOrderDateSetter: false,
    },
    {
      id: "2",
      name: "JSW Neosteel TMT Fe 500D 12 mm",
      subtitle: "Private brand · VM-042",
      quantity: "10 MT",
      materialReady: "72 h",
      serviceCentre: "12 h",
      processing: "46 h",
      logistics: "36 h",
      nonWorking: "40 h",
      committedDate: "10 OCT 2026",
      isOrderDateSetter: true,
      tag: "Sets order date",
    },
    {
      id: "3",
      name: "CRCA Sheet 1.2 × 1250 × 2500 mm",
      subtitle: "Distributed · V-PUNE-01",
      quantity: "5 MT",
      materialReady: "48 h",
      serviceCentre: "12 h",
      processing: "46 h",
      logistics: "36 h",
      nonWorking: "40 h",
      committedDate: "09 OCT 2026",
      isOrderDateSetter: false,
    },
  ],
  processingFormulaNote:
    "Processing includes payment verification, DO release, JOTS vehicle reporting, and dispatch SLAs. Buffer hours are included in committed dates.",
};
